<template>
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <!-- <div class="row mb-3">
        <div class="col-sm-3">
          <multiselect
            v-model="filters.status"
            label="name"
            track-by="value"
            :options="filters.statusOptions"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :allow-empty="false"
            placeholder="Կարգավիճակ"
          />
        </div>
      </div> -->
      <!-- Tab panes -->
      <div class="row">
        <div class="col-12 tenders-list">
            <v-server-table
              ref="vtable"
              :url="`${proxyUrl}contract-orders/getByProvider`"
              :options="options"
              :columns="columns"
            >
              <div slot="contract_code" class="more d-flex justify-content-center" slot-scope="{row}">
                {{row.contract.code}}
              </div>
              <div slot="provider_name" class="more d-flex justify-content-center" slot-scope="{row}">
                {{row.contract.client.name}}
              </div>
              <div slot="lots_count" class="more d-flex justify-content-center" slot-scope="{row}">
                {{row.lots.length}}
              </div>
              <div slot="lots" slot-scope="{row}">
                <span v-for="(lot, lotIndex) in row.lots" :key="lot.id">{{lot.lot_info.name}}<span v-if="lotIndex !== row.lots.length-1">, </span></span>
              </div>
              <div slot="date" class="more d-flex justify-content-center" slot-scope="{row}">
                {{row.organize.code}}
              </div>
              <div slot="status" class="more d-flex justify-content-center" slot-scope="{row}">
                {{getStatus(row)}}
              </div>
              <div slot="invoice_details" class="more d-flex justify-content-center" slot-scope="{row}">
                <div class="row align-items-center justify-left">
                  <div class='col-12 mb-2 text-center'>
                    {{row.is_full ? ' Դուրս գրված է' : 'Դուրս գրված չէ' }}
                  </div>
                  <div class='col-12 mb-2 text-primary text-left'>
                    <button
                      v-if="!row.is_full"
                      class="btn btn-primary btn-sm btn-block"
                      @click="$modal.show('invoice-details-modal', {order: row, resetComponent})"
                    >
                      Դուրս գրել <i class="fas fa-edit ml-1"/> 
                    </button>
                  </div>
                </div>
              </div>
              <div slot="total_price" class="more d-flex justify-content-center" slot-scope="{row}">
                {{getTotalPrice(row)}}
              </div>
              <div slot="delete" class="d-flex justify-content-center">
                <i class="mdi mdi-delete text-danger" style="font-size: 30px; cursor: pointer;"></i>
              </div>
              <div slot="docs" slot-scope="{row}">
                <div class="row align-items-center justify-left">
                  <div class='col-12 mb-2 text-primary text-left'>
                    <button
                      class="btn btn-primary btn-sm btn-block"
                      :disabled="!row.is_full"
                      @click.prevent="() => {
                        $modal.show('new-editor-modal', {
                          action: 'download',
                          fileName: 'transfer_protocol',
                          participantGroup: row,
                          editorTitle: 'Հանձնման ընդունման արձանագրություն'
                        })
                      }"
                      >
                      <i class="fas fa-file-alt mr-1" /> Հանձնման ընդունման արձանագրություն
                    </button>
                  </div>
                  <div v-if="row.contract.organize_type !== 'itender'" class='col-12 mb-2 text-primary text-left'>
                    <button
                      class="btn btn-primary btn-sm btn-block"
                      :disabled="!row.is_full"
                      @click.prevent="() => {
                        $modal.show('new-editor-modal', {
                          action: 'download',
                          fileName: 'act',
                          participantGroup: row,
                          editorTitle: 'Ակտ'
                        })
                      }"
                      >
                      <i class="fas fa-file-alt mr-1" /> Ակտ
                    </button>
                  </div>
                </div>
              </div>
            </v-server-table>
        </div>
        <invoice-details-modal />
        <new-editor-modal />
      </div>
    </div>
  </div>
</template>

<script>
  import InvoiceDetailsModal from '../modals/InvoiceDetailsModal'
  import NewEditorModal from '@/views/fileManagment/contractManagement/NewEditorModal'
  export default {
    data() {
      return {
        proxyUrl: process.env.VUE_APP_API_URL,
        columns: ['contract_code', 'provider_name', 'lots_count', 'lots', 'total_price', 'status', 'invoice_details', 'docs'],
        options: {
          requestAdapter (data) {
            return {
              limit: data.limit ? data.limit : 5,
              page: data.page,
              status: 'active',
            }
          },
          responseAdapter({data}) {
            return { 
              data: data.data, 
              count: data.count
            }
          },
          requestFunction(data) {
            return this.$client.get(this.url, {params: data})
            .catch(function (e) {this.dispatch('error', e)})
          },
          params:{ 
            component: this
          },
          sortable: [],
          columnsDropdown: false,
          pagination: { chunk: 1 },
          filterByColumn: false,
          dateColumns:['create_date','end_date'],
          dateFormat: "YYYY-mm-dd",
          headings: {
            contract_code: 'Պայմանագրի ծածկագիր',
            provider_name: 'Պատվիրատուի անվանում',
            completion_actual_date: 'Ամսաթիվ',
            lots_count: 'Գնման առարկաների քանակ',
            lots: 'Գնման առարկաներ',
            total_price: 'Ընդհանուր գումար',
            status: 'Կարգավիճակ',
            invoice_details: 'Հաշիվ ապրանքագիր',
            docs: 'Փաստաթղթեր',
          },
          texts: {
            count: 'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
            first: 'Առաջին',
            last: 'Վերջին',
            filter: '',
            filterPlaceholder: 'Փնտրել',
            limit: '',
            page: 'Page:',
            noResults: 'Համընկնում չի գտնվել',
            noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
            filterBy: 'փնտրել ըստ {column}',
            loading: 'Բեռնվում է...',
            defaultOption: 'ընտրել {column}',
            columns: 'Ընտրել դաշտերը',
          },
          filterable: false
        },
        filters: {
          status: { name: 'Բոլորը', value: 'all' },
          statusOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Ակտիվ առաջարկներ', value: 'active' },
            { name: 'Ավարտված առաջարկներ', value: 'finished' },
          ],
        }
      }
    },
    components: {InvoiceDetailsModal, NewEditorModal},
    computed: {
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      locale() {
        return this.$store.getters['user/locale']
      },
      me() {
        return this.$store.getters['user/me']
      },
    },
    mounted() {
      // 
    },
    methods: {
      getTotalPrice({lots}){
        var totalPrice = 0;
        lots.forEach((lot) => {
          totalPrice += lot.ordered * lot.lot_info.price_unit
        })
        return totalPrice;
      },
      getStatus({status}){
        switch (status) {
          case 'sended':
            return 'Պատվիրված'
          case 'completed':
            return 'Մատակարարված'
          case 'failed':
            return 'Առաջացել է խնդիր'
          case 'canceled':
            return 'Չկատարված'
          default:
            break;
        }
      },
      async resetComponent() {
        await this.$refs.vtable.refresh()
      },
    },
  }
</script>